import { render, staticRenderFns } from "./UpdatePriceForm.vue?vue&type=template&id=3bac371e&"
import script from "./UpdatePriceForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports